import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { ClassificacaoModel } from 'model/api/gestao/classificacao/classificacao-model';

export function usePutPessoaClassificacao() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const putPessoaClassificacao = useCallback(
        (model: ClassificacaoModel) =>
            invocarApi({
                method: 'PUT',
                url: `/${VariaveisAmbiente.apiVersion}/pessoa-classificacao`,
                data: model,
                enviarTokenUsuario: true
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        putPessoaClassificacao,
    };
}
